import React from 'react';
import classNames from 'classnames';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/topupStyle';
import { makeStyles } from '@material-ui/core';
import Payment from './subcomponents/Payment';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import { translate } from 'components/Translation';
import { IPaymentToken } from 'utils/api/models/payments/paymentTokens';

interface IndexProps {
	totalAmount: number;
	formData: types.payment.IFormData;
	onBack: () => void;
	selectedDonation: types.payment.IDonation | null;
	topUpError?: string | null;
	setFormCardData: types.payment.setFormData;
	setTokenData: (token: IPaymentToken) => void;
	toggleSaveCard: () => void;
	setSaveCard: (saveCard: boolean) => void;
	checkValidity: boolean;
	setCheckValidity: React.Dispatch<React.SetStateAction<boolean>>;
	selectedNumbers: types.topUp.INumber[];
	topUpLimit: types.payment.paymentLimitReached;
	handleTopUp: (formData: any) => void;
	showForm: boolean;
}

// @ts-ignore
const useStyles = makeStyles(styles);

const Index = (props: IndexProps) => {
	const {
		totalAmount,
		formData,
		onBack,
		selectedDonation,
		setFormCardData,
		setTokenData,
		topUpError,
		checkValidity,
		setCheckValidity,
		selectedNumbers,
		topUpLimit,
		handleTopUp,
		showForm,
		toggleSaveCard,
		setSaveCard,
	} = props;

	const classes = useStyles();

	return (
		<>
			<ConditionalRender
				show={showForm}
				onFalse={() => (
					<Payment
						selectedElements={selectedNumbers}
						totalAmount={totalAmount}
						handleTopUp={handleTopUp}
						topUpError={topUpError}
						formData={formData}
						setFormCardData={setFormCardData}
						checkValidity={checkValidity}
						setCheckValidity={setCheckValidity}
						selectedDonation={selectedDonation}
						topUpLimit={topUpLimit}
						onBack={onBack}
						setTokenData={setTokenData}
						toggleSaveCard={toggleSaveCard}
						setSaveCard={setSaveCard}
					/>
				)}
				onTrue={() => (
					<div className={classNames(classes.wrapper, classes.paymentLoading)}>
						<CustomCircularProgress text={translate('topup.pleaseWait')} loading transparent />
					</div>
				)}
			/>
		</>
	);
};

export default Index;
